import { ISearch } from './ISearch.model';

export class Person implements ISearch {
  public id: string;
  public name: string;
  public desc: string;
  public email: string;
  public phone: string;
  public language: string;
  public applicationTypes: number[] = [];
  public localEntities: string[] = [];
  public currentApplicationType: number;
  public permissions: string[] = [];
  public authorizations: any;
  public productLine: string;
  public isHost: boolean;
  public office: string;
  public username: string;
  public function: string;
  public personType: number;

  isAdmin(): boolean {
    const admin = 'admin';
    return this.name != null && this.name.toLowerCase().indexOf(admin) !== -1;
  }

  public search(query: string): boolean {
    const queryToLower = query.toLowerCase();
    const phone = this.phone ? this.phone.split(' ').join('').split('-').join('') : '';
    return (
      (this.name != null && this.name.toLowerCase().indexOf(queryToLower) !== -1) ||
      (this.desc != null && this.desc.toLowerCase().indexOf(queryToLower) !== -1) ||
      (this.username != null && this.username.toLowerCase().indexOf(queryToLower) !== -1) ||
      (this.email != null && this.email.toLowerCase().indexOf(queryToLower) !== -1) ||
      (this.phone != null && this.phone.toLowerCase().indexOf(queryToLower) !== -1) ||
      (phone && phone != null && phone.toLowerCase().indexOf(queryToLower) !== -1)
    );
  }

  isOptimizationCurrentApp() {
    return this.currentApplicationType === 1;
  }
}

export class PermissionModel {
  constructor(public label: string, public value: string) {}
}

export class CurrencyModel {
  constructor(public label: string, public value: string) {}
}

export class LocalEntityModel {
  constructor(public label: string, public value: string, public countries: string[]) {}
}
